




















































































































































import Vue from "vue";
import axios from "axios";

import Mark, { MarkOptions } from "mark.js";

import { sortedUniq, uniqBy } from "lodash";

import {
  sortedDataAttributes,
  DataAttribute,
  getConfiguration,
  getConfigurationAsDataItems,
  DataItem
} from "@/model/DataViewConfigurationHelper";

export default Vue.extend({
  name: "",
  components: {},
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      document: null as DataItem | null,
      currentTab: 0,
      processInProgress: false,
      selectedEntities: [] as any[],
      selectedCategories: {} as any[],
      languageOptions: [
        {
          label: "English",
          value: "eng"
        },
        {
          label: "German",
          value: "deu"
        }
      ],
      modeOptions: [
        {
          label: "Lenient",
          value: "lenient"
        },
        {
          label: "Default",
          value: "default"
        },
        {
          label: "Strict",
          value: "strict"
        }
      ],
      searchEntity: "",
      entityHeaders: [
        { text: "Text", value: "plaintext", sortable: true },
        { text: "Redacted", value: "pseudonym", sortable: true },
        { text: "Category", value: "entity_type", sortable: true },
        { text: "Color", value: "color", sortable: false }
      ] as any[],
      markupVisible: true,
      // made from https://gka.github.io/palettes/#/40|d|b26cca,96ffea,90ee90,6476ff,ffc0cb,ffa500|ffffe0,f13b28,add8e6,ac944e|0|0
      colorArray: [
        "#b26cca",
        "#ab91d2",
        "#a4b6da",
        "#9ddae2",
        "#96ffea",
        "#95fbd4",
        "#93f7bd",
        "#92f2a7",
        "#90ee90",
        "#85d0ac",
        "#7ab2c8",
        "#6f94e3",
        "#6476ff",
        "#8b89f2",
        "#b19be5",
        "#d8aed8",
        "#ffc0cb",
        "#ffb998",
        "#ffb366",
        "#ffac33",
        "#fde2c4",
        "#fbc4a9",
        "#f9a78d",
        "#f78972",
        "#f56c56",
        "#f24f3a",
        "#ee4332",
        "#e35a4e",
        "#d9726b",
        "#cf8a87",
        "#c5a1a4",
        "#bbb9c0",
        "#b0d0dd",
        "#add1d7",
        "#adc7c0",
        "#adbda9",
        "#acb392",
        "#aca87c",
        "#ac9e65",
        "#ac944e"
      ]
    };
  },
  watch: {
    id: {
      async handler() {
        await this.loadDocument();
      },
      immediate: true
    },
    markSearchStrings: {
      async handler() {
        await this.refreshMark();
      },
      immediate: false
    },
    markupVisible: {
      async handler() {
        await this.refreshMark();
      },
      immediate: false
    },
    "attributes.language": {
      async handler(newValue: string) {
        this.updateAttributes({ language: newValue });
      }
    },
    "attributes.mode": {
      async handler(newValue: string) {
        this.updateAttributes({ mode: newValue });
      }
    }
  },
  computed: {
    listUrl(): string {
      return `${process.env.VUE_APP_API_URL}/model/documents/list`;
    },
    findUrlBase(): string {
      return `${process.env.VUE_APP_API_URL}/model/documents/find/`;
    },
    findUrl(): string {
      return `${this.findUrlBase}${this.id}`;
    },
    saveUrl(): string {
      return `${process.env.VUE_APP_API_URL}/model/documents/update`;
    },
    saveFileUrl(): string {
      return `${process.env.VUE_APP_API_URL}/model/files/savefile`;
    },
    pseudoUrl(): string {
      return `${process.env.VUE_APP_PSEUDO_URL}/pseudo`;
    },
    attributes(): any {
      return this.document ? this.document.attributes : null;
    },
    pseudoResult(): any {
      return this.attributes ? this.attributes.pseudoResult : null;
    },
    entities(): any[] {
      return this.pseudoResult && this.pseudoResult.entities
        ? this.pseudoResult.entities
        : [];
    },
    uniqueEntities(): any[] {
      return this.entities ? uniqBy(this.entities, "plaintext") : [];
    },
    entityCategories(): string[] {
      return this.uniqueEntities
        ? uniqBy(this.uniqueEntities, "entity_type").map(
            (e: any) => e.entity_type
          )
        : [];
    },
    categoriesFullSelected(): any {
      const result = {} as any;
      for (const category of this.entityCategories) {
        let allSelected = true;
        const categoryEntities = this.entities.filter(
          e => e.entity_type === category
        );
        for (const entity of categoryEntities) {
          if (
            !this.selectedEntities.find(se => se.text_hash === entity.text_hash)
          ) {
            // console.log(this.selectedEntities);
            // console.log(entity);
            allSelected = false;
            break;
          }
        }
        result[category] = allSelected;
      }
      return result;
    },
    colors(): string[] {
      const result = this.colorArray;
      for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * i);
        const temp = result[i];
        result[i] = result[j];
        result[j] = temp;
      }
      return result;
    },
    pseudoText(): string {
      let text: string = this.pseudoResult?.text_pseudo ?? "";
      while (text.startsWith("\n")) {
        text = text.replace("\n", "");
      }
      return text;
    },
    markSearchStrings(): any {
      const markSearchStringsPlain = [] as string[];
      const markSearchStringsPseudo = [] as string[];
      const markSearchString = {};
      for (const entity of this.uniqueEntities) {
        if (entity.plaintext.length < 3) {
          // don't mark super short strings.
          continue;
        }
        if (
          !this.selectedEntities.find(
            selectedEntity => selectedEntity.plaintext === entity.plaintext
          )
        ) {
          // skip not selected entities
          continue;
        }
        markSearchStringsPlain.push(entity.plaintext.toLowerCase());
        markSearchStringsPseudo.push(`|${entity.text_hash.toLowerCase()}|`);
      }

      return { plain: markSearchStringsPlain, pseudo: markSearchStringsPseudo };
    },
    entityColorMap(): any {
      const entityColorMap: any = {};
      const hashColorMap: any = {};
      let colorIndex = 0;
      for (const entity of this.entities) {
        if (entity.plaintext.length < 3) {
          // don't mark super short strings.
          continue;
        }
        const color = hashColorMap[entity.text_hash]
          ? hashColorMap[entity.text_hash]
          : colorIndex >= this.colors.length
          ? "pink"
          : this.colors[colorIndex];

        if (!hashColorMap[entity.text_hash]) {
          hashColorMap[entity.text_hash] = color;
          colorIndex++;
        }

        // const plainRegex = `/${entity.plaintext}/gmi`;
        // const pseudoRegex = `/<\\w+\\|${entity.text_hash}\\|\\w+>/gmi`;
        entityColorMap[entity.plaintext.toLowerCase()] = color;
        entityColorMap[
          entity.pseudonym
            .replace("<", "")
            .replace(">", "")
            .toLowerCase()
            .trim()
        ] = color;
      }
      return entityColorMap;
    }
  },
  methods: {
    async loadDocument() {
      console.log("loading doc");
      // this.markContent(false);
      this.selectedEntities = [];
      this.document = (await axios.get(this.findUrl)).data;
      await this.$nextTick();
      // this.markContent(true);
    },
    async processDoc() {
      this.processInProgress = true;
      console.log(this.pseudoUrl);
      axios
        .post(this.pseudoUrl, {
          Text: this.attributes.content,
          Language: this.attributes.language || "eng",
          Mode: this.attributes.mode || "default"
        })
        .then(async result => {
          console.log(result);
          const pseudoData = result.data;
          for (const entity of pseudoData.entities) {
            entity.plaintext = entity.plaintext.replace(/ +(?= )/g, "").trim();
          }
          await this.updateAttributes({
            pseudoResult: result.data
          });
        })
        .catch(error => {
          console.error(error);
          this.displaySnack("Redacting failed, please try again in a minute", {
            color: "error"
          });
        })
        .finally(() => {
          this.processInProgress = false;
        });
    },
    async updateAttributes(newAttributes: any) {
      await axios.post(this.saveUrl, {
        selector: { id: this.id },
        attributes: newAttributes
      });
      await this.loadDocument();
    },
    toggleMarkup() {
      this.markupVisible = !this.markupVisible;
    },
    selectEntity(entity: any, row: any) {
      console.log(row);
      row.select(!row.isSelected);
    },
    selectCategory(category: string, selected: boolean) {
      const categoryItems = this.uniqueEntities.filter(
        e => e.entity_type === category
      );
      if (selected) {
        this.selectedEntities = uniqBy(
          [...this.selectedEntities, ...categoryItems],
          "plaintext"
        );
      } else {
        this.selectedEntities = this.selectedEntities.filter(
          e => e.entity_type !== category
        );
      }
    },
    selectAllEntities(payload: any) {
      // console.log(payload);
      if (payload.value) {
        this.selectedEntities = [...this.entities];
      } else {
        this.selectedEntities = [];
      }
    },
    refreshMark() {
      const mark = new Mark("#textcontentrow");
      const markOrig = new Mark("#origcontent");
      const markPseudo = new Mark("#pseudocontent");
      mark.unmark();

      if (this.markupVisible) {
        const markOptionsPseudo: MarkOptions = {
          className: "highlight",
          // accuracy: "partially",
          accuracy: {
            value: "complementary",
            limiters: [
              "<",
              ">" //, "-", ",", ".", "@", "(", ")", ";"]
            ]
          },
          wildcards: "disabled",
          separateWordSearch: false,
          ignoreJoiners: true,
          diacritics: false,
          each: (element: any) => {
            const term = `${element.innerText
              .replace(/\n/g, "")
              .replace(/\r/g, "")
              .trim()
              .toLowerCase()}`;
            // console.log(element);
            // console.log(this.entityColorMap);
            element.style.backgroundColor = this.entityColorMap[term];
          }
        };

        const markOptionsPlain = { ...markOptionsPseudo };
        markOptionsPlain.accuracy = {
          value: "exactly",
          limiters: ["<", ">", "-", ",", ".", "@", "(", ")", ";"]
        };
        markOptionsPlain.wildcards = "disabled";
        markOrig.mark(this.markSearchStrings.plain, markOptionsPlain);
        markPseudo.mark(this.markSearchStrings.pseudo, markOptionsPseudo);
      }
    }
    // markContent(show: boolean) {

    //   if (this.pseudoResult) {
    //     const mark = new Mark("#textcontentrow");
    //     if (!show) {
    //       mark.unmark();
    //     } else {
    //       const markOptions: MarkOptions = {
    //         className: "highlight",
    //         accuracy: "partially",
    //         wildcards: "enabled",
    //         separateWordSearch: false,
    //         each: (element: any) => {
    //           element.style.backgroundColor = this.entityColorMap[
    //             element.innerText.toLowerCase()
    //           ];
    //         }
    //       };
    //       mark.mark(this.markSearchStrings, markOptions);
    //     }
    //   }
    //   this.markupVisible = show;
    // }
  }
});
